import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";
import Replay from "@/pages/Replay";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/replay" element={<Replay />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/privacy-policy" element={<LegalPage page="privacy" />} />
        <Route path="/terms" element={<LegalPage page="terms" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
